module.exports = __webpack_public_path__ + "gm.d2b4a063bb9e7890879f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gm.svg
// module chunks = styles